import { Input } from '@/components/shadcn/Input';

type Props = {
  value: string;
  onChange: (arg: any) => void;
  placeholder: string;
  errorMessage: string | undefined;
  className?: string;
};

export default function PhoneNumber({
  value,
  onChange,
  placeholder,
  errorMessage,
  className
}: Props) {
  return (
    <>
      <Input
        type="tel" // アクセシビリティ用
        name="phoneNumber" // アクセシビリティ用
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
      />
      {errorMessage ? (
        <p className="ml-[10px] mt-[5px] text-[12px] font-semibold text-[#d92f2b]">
          {errorMessage}
        </p>
      ) : null}
    </>
  );
}
